import { Component, Input } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { getMoment, date } from 'src/app/modules/core/services/datetime.service';
import { VersionService } from 'src/app/modules/core/services/version.service';

@Component({
  selector: 'app-default-footer',
  templateUrl: './default-footer.component.html',
  styleUrls: ['./default-footer.component.scss'],
})
export class DefaultFooterComponent {
  @Input()
  public isLogin: boolean;

  public currentYear: number;
  public version: string;
  public showVersion: boolean;

  constructor(private readonly _versionService: VersionService, private readonly router: Router) {
    this.version = this._versionService.getVersion();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.showVersion = event.urlAfterRedirects === '/login';
      }
    });

    this.currentYear = getMoment(date()).year();
  }
}
